import { Component, computed, input, output } from '@angular/core';
import { SpecialWizard } from '../../models/core/special-wizard';
import { SpecialItemComponent } from "../special-item/special-item.component";
import { OrderableSpecialStepAlternativeItem } from '../../models/menu/orderable-special-step-alternative-item.model';
import { OrderableItem } from '../../models/menu/orderable-item.model';
import { OrderedItem } from '../../models/ordering/ordered-item.model';

@Component({
  selector: 'cwo-special-items-list',
  standalone: true,
  imports: [SpecialItemComponent],
  templateUrl: './special-items-list.component.html',
  styleUrl: './special-items-list.component.scss'
})
export class SpecialItemsListComponent {
  specialWizard = input.required<SpecialWizard | null>();
  readonly itemSelected = output<{
    orderableItem: OrderableItem;
    orderedItem: OrderedItem;
}>();


  onItemSelected(event:{orderableItem:OrderableItem, orderedItem:OrderedItem}) {
    this.itemSelected.emit(event)
  }
  currentStepItems = computed<OrderableSpecialStepAlternativeItem[]>(() => {
    return this.specialWizard()?.currentStep?.allItems ?? [];
  });

  isSelected(item: OrderableSpecialStepAlternativeItem): boolean {
    return this.specialWizard()?.currentStep?.isSelectedAlternativeItem(item) ?? false;
  }

}
